import { render } from "./Akaun.vue?vue&type=template&id=516fc62b"
import script from "./Akaun.vue?vue&type=script&lang=js"
export * from "./Akaun.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__